import { Application, Controller } from "@hotwired/stimulus";
import { uploadToS3 } from '@/modules/directUploader/index';

// S3に画像をダイレクトアップロードし、hiddenタグにアップロードした画像のメタデータを格納する
class DirectUploadController extends Controller {
  static targets = ['fileInput', 'metaDataField', 'preview', 'previewWrapper', 'removeFlag']

  connect() {
    // 既に登録済みの画像データやキャッシュデータがある場合はプレビューを表示する
    if (this.previewTarget.getAttribute('src')) {
      this.previewWrapperTarget.classList.remove('d-none');
      this.fileInputTarget.classList.add('d-none');
    }
  }

  upload(event) {
    const file = event.target.files[0];

    if (!file) return;

    uploadToS3(file)
      .then((data) => {
        this.metaDataFieldTarget.value = JSON.stringify(data);
        this.setPreviewImage(file);
        this.fileInputTarget.classList.add('d-none');
        this.removeFlagTarget.value = '';
      })
      .catch(() => { this.metaDataFieldTarget.value = '' });
  }

  setPreviewImage(file) {
    const reader = new FileReader();
    reader.onload = (event) => {
      const image_data = event.target?.result;
      if (typeof image_data !== 'string') return;

      this.previewWrapperTarget.classList.remove('d-none');
      this.previewTarget.src = image_data;
    };
    reader.readAsDataURL(file);
  }

  removeFile() {
    this.metaDataFieldTarget.value = '';
    this.fileInputTarget.value = '';
    this.previewTarget.src = '';
    this.fileInputTarget.classList.remove('d-none');
    this.previewWrapperTarget.classList.add('d-none');
    this.removeFlagTarget.value = '1';
  }
}

// Registered in admin.js
export { DirectUploadController };
